import { GetToolResultResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetToolResultResponse } from '@/types/Psychosocial';

export class GetToolResultMapper {
	constructor(private readonly data: GetToolResultResponseDTO) {}

	toDomain(): GetToolResultResponse {
		const result = { ...this.data };

		if (result.nasa_tlx && result.nasa_tlx.tool_results) {
			result.nasa_tlx.tool_results = result.nasa_tlx.tool_results.filter(
				(item) => item.category !== 'workload' && item.category !== null
			);
		}

		if (result.hse_it && Array.isArray(result.hse_it.tool_results)) {
			result.hse_it.tool_results = result.hse_it.tool_results.filter((item) => item.category !== null);
		}

		return result;
	}
}
